const metadata = {
  id: 5,
  name: `Writing a Survey for a Vulnerable Population: Chaplaincy Services in Federal Prisons`,
  metadata: {
    description: `This case discusses social scientific research of religion in a carceral setting. The
Federal Bureau of Prison’s Chaplaincy Services enables federal inmates to practice religion while incarcerated. A researcher designed a survey to help Chaplaincy Services learn more about religious prisoners. This case discusses common difficulties with studying a vulnerable population, such as prisoners.
`,
    objectives: [`Identify the basics of survey research with a vulnerable population.`, `Consider the challenges of tabulating data gathered by a quantitative survey.`,`Describe the role of Chaplaincy Services in Federal Prisons.` ],
    themes: [`Undergraduate methods students in the social sciences`, `Chaplaincy students with an interest in research`],

  },
  image:
    "https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/section_anm1.jpg",
  slug: "survey-for-vulnerable-population",
  title: `Writing a Survey for a Vulnerable Population: Chaplaincy Services in Federal Prisons`,
}

export default metadata;